export default function Blog() {
    return (
        <section>
            <div className="container overlap-gap-section pb-3">
                <div className=" justify-content-center align-items-center mb-6" data-anime='{ "el": "childs", "translateY": [30, 1], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue":200, "easing": "easeOutQuad" }'>

                    <div className="col-12 col-md-auto ps-25px sm-ps-15px text-center">
                        <h3 className="fw-600 text-dark-gray ls-minus-1px mb-0">Novedades</h3>
                    </div>
                    <div className="col-12 col-md-auto ps-25px sm-ps-15px text-center">
                        <span className="fs-20 text-dark-gray fw-600">No te pierdas ni un solo detalle</span>
                    </div>

                </div>
                <div className="row row-cols-1 row-cols-lg-3 row-cols-md-2 transition-inner-all justify-content-center" data-anime='{ "el": "childs", "translateY": [20, 0], "opacity": [0,1], "duration": 600, "delay": 300, "staggervalue": 300, "easing": "easeOutQuad" }'>

                    <div className="col mb-20px">
                        <div className="services-box-style-01 hover-box">
                            <div className="position-relative box-image border-radius-6px overflow-hidden">
                                <a href="#">
                                    <img src="https://placehold.co/755x510" alt="" />
                                    <div className="box-overlay bg-black-transparent-medium"></div>
                                    <span className="d-flex justify-content-center align-items-center mx-auto icon-box absolute-middle-center z-index-1 w-65px h-65px rounded-circle border border-color-transparent-white border-1"><i className="bi bi-arrow-right-short text-white icon-very-medium d-flex"></i></span>
                                </a>
                            </div>
                            <div className="p-25px last-paragraph-no-margin text-center">
                                <span className="fs-20 text-dark-gray fw-600">Example</span>
                                <p className="lh-26">Example</p>
                            </div>
                        </div>
                    </div>


                    <div className="col mb-20px">
                        <div className="services-box-style-01 hover-box">
                            <div className="position-relative box-image border-radius-6px overflow-hidden">
                                <a href="#">
                                    <img src="https://placehold.co/755x510" alt="" />
                                    <div className="box-overlay bg-black-transparent-medium"></div>
                                    <span className="d-flex justify-content-center align-items-center mx-auto icon-box absolute-middle-center z-index-1 w-65px h-65px rounded-circle border border-color-transparent-white border-1"><i className="bi bi-arrow-right-short text-white icon-very-medium d-flex"></i></span>
                                </a>
                            </div>
                            <div className="p-25px last-paragraph-no-margin text-center">
                                <span className="fs-20 text-dark-gray fw-600">Example</span>
                                <p className="lh-26">Example</p>
                            </div>
                        </div>
                    </div>


                    <div className="col mb-20px">
                        <div className="services-box-style-01 hover-box">
                            <div className="position-relative box-image border-radius-6px overflow-hidden">
                                <a href="#">
                                    <img src="https://placehold.co/755x510" alt="" />
                                    <div className="box-overlay bg-black-transparent-medium"></div>
                                    <span className="d-flex justify-content-center align-items-center mx-auto icon-box absolute-middle-center z-index-1 w-65px h-65px rounded-circle border border-color-transparent-white border-1"><i className="bi bi-arrow-right-short text-white icon-very-medium d-flex"></i></span>
                                </a>
                            </div>
                            <div className="p-25px last-paragraph-no-margin text-center">
                                <span className="fs-20 text-dark-gray fw-600">Example</span>
                                <p className="lh-26">Example</p>
                            </div>
                        </div>
                    </div>


                    <div className="col md-mb-20px">
                        <div className="services-box-style-01 hover-box">
                            <div className="position-relative box-image border-radius-6px overflow-hidden">
                                <a href="#">
                                    <img src="https://placehold.co/755x510" alt="" />
                                    <div className="box-overlay bg-black-transparent-medium"></div>
                                    <span className="d-flex justify-content-center align-items-center mx-auto icon-box absolute-middle-center z-index-1 w-65px h-65px rounded-circle border border-color-transparent-white border-1"><i className="bi bi-arrow-right-short text-white icon-very-medium d-flex"></i></span>
                                </a>
                            </div>
                            <div className="p-25px last-paragraph-no-margin text-center">
                                <span className="fs-20 text-dark-gray fw-600">Example</span>
                                <p className="lh-26">Example</p>
                            </div>
                        </div>
                    </div>


                    <div className="col sm-mb-20px">
                        <div className="services-box-style-01 hover-box">
                            <div className="position-relative box-image border-radius-6px overflow-hidden">
                                <a href="#">
                                    <img src="https://placehold.co/755x510" alt="" />
                                    <div className="box-overlay bg-black-transparent-medium"></div>
                                    <span className="d-flex justify-content-center align-items-center mx-auto icon-box absolute-middle-center z-index-1 w-65px h-65px rounded-circle border border-color-transparent-white border-1"><i className="bi bi-arrow-right-short text-white icon-very-medium d-flex"></i></span>
                                </a>
                            </div>
                            <div className="p-25px last-paragraph-no-margin text-center">
                                <span className="fs-20 text-dark-gray fw-600">Example</span>
                                <p className="lh-26">Example</p>
                            </div>
                        </div>
                    </div>


                    <div className="col">
                        <div className="services-box-style-01 hover-box">
                            <div className="position-relative box-image border-radius-6px overflow-hidden">
                                <a href="#">
                                    <img src="https://placehold.co/755x510" alt="" />
                                    <div className="box-overlay bg-black-transparent-medium"></div>
                                    <span className="d-flex justify-content-center align-items-center mx-auto icon-box absolute-middle-center z-index-1 w-65px h-65px rounded-circle border border-color-transparent-white border-1"><i className="bi bi-arrow-right-short text-white icon-very-medium d-flex"></i></span>
                                </a>
                            </div>
                            <div className="p-25px last-paragraph-no-margin text-center">
                                <span className="fs-20 text-dark-gray fw-600">Example</span>
                                <p className="lh-26">Example</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}